export function notificationRoute(notification) {
  const d = { ...notification, ...(notification.data || {}) };
  const type = String(d.type || "").toUpperCase();
  const enc = encodeURIComponent;
  if (type === "FRIEND_REQUEST") return null;
  if (type === "FRIEND_ACCEPTED")
    return d.senderId ? `/user-profile/${enc(d.senderId)}` : "/notifications";
  if (type === "JOB_FILLED" || type === "JOB_HIRED") return "/my-applications";
  if (type === "REVIEW") return "/profile#profile-reviews";
  if (type === "ADMIN_APPROVAL_QUEUE") return "/admin/approvals";
  if (type === "ADMIN_REPORT") return "/settings";
  if (d.groupId) return `/group-chat/${enc(d.groupId)}`;
  if (d.communityId) return `/community/${enc(d.communityId)}`;
  if (d.jobId) return `/jobs/${enc(d.jobId)}`;
  if (d.senderId) return `/chat/${enc(d.senderId)}`;
  return null;
}

// Transaction builders deliberately touch only the captured, displayed IDs.
export function markNotificationsRead(current, ids) {
  if (!current) return;
  const next = { ...current };
  let changed = false;
  ids.forEach((id) => {
    if (next[id] && next[id].read !== true) {
      next[id] = { ...next[id], read: true };
      changed = true;
    }
  });
  return changed ? next : undefined;
}
export function deleteNotifications(current, ids) {
  if (!current) return;
  const next = { ...current };
  let changed = false;
  ids.forEach((id) => {
    if (Object.prototype.hasOwnProperty.call(next, id)) {
      delete next[id];
      changed = true;
    }
  });
  return changed ? next : undefined;
}
